function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.5998 13.6H2.3998V2.40005H13.5998V13.6ZM13.5998 0.800049H2.3998C1.97546 0.800049 1.56849 0.96862 1.26843 1.26868C0.968376 1.56874 0.799805 1.9757 0.799805 2.40005V13.6C0.799805 14.0244 0.968376 14.4314 1.26843 14.7314C1.56849 15.0315 1.97546 15.2001 2.3998 15.2001H13.5998C14.0242 15.2001 14.4311 15.0315 14.7312 14.7314C15.0312 14.4314 15.1998 14.0244 15.1998 13.6V2.40005C15.1998 1.51205 14.4798 0.800049 13.5998 0.800049ZM11.5998 11.4001C11.5998 10.2 9.19981 9.60005 7.99981 9.60005C6.79981 9.60005 4.39981 10.2 4.39981 11.4001V12H11.5998V11.4001ZM7.99981 8.20005C8.4772 8.20005 8.93503 8.01041 9.2726 7.67284C9.61016 7.33528 9.79981 6.87744 9.79981 6.40005C9.79981 5.92266 9.61016 5.46482 9.2726 5.12726C8.93503 4.78969 8.4772 4.60005 7.99981 4.60005C7.52242 4.60005 7.06458 4.78969 6.72701 5.12726C6.38945 5.46482 6.19981 5.92266 6.19981 6.40005C6.19981 6.87744 6.38945 7.33528 6.72701 7.67284C7.06458 8.01041 7.52242 8.20005 7.99981 8.20005Z",
  fill: "#6F62FF"
});

var SvgAccount = function SvgAccount(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAccount, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/account.e40cde02.svg";
export { ForwardRef as ReactComponent };